import React, { useState } from "react";
import { HttpService } from "../../apiAuthorization/httpService";

export const ServiceRecovery = React.createContext(null);

export const ServiceRecoveryContext = props => {
    let storedRecoveryIssue = JSON.parse(localStorage.getItem("recoveryIssue"));
    let storedRecoveryResolution = JSON.parse(localStorage.getItem("recoveryResolution"));

    const [recoveryIssue, setRecoveryIssue] = useState(storedRecoveryIssue === null ? [] : storedRecoveryIssue);
    const [issueLoaded, setIssueLoaded] = useState('');

    const [recoveryResolution, setRecoveryResolution] = useState(storedRecoveryResolution === null ? [] : storedRecoveryResolution);
    const [resolutionLoaded, setResolutionLoaded] = useState('');


    const getRecoveryIssue = () => {
        HttpService.post('/ServiceRecovery/GetRecoveryIssue', {
            data: null,
        })
            .then((result) => {
                console.log("Recovery issue : " + result[0])
                setRecoveryIssue(result);
                localStorage.setItem("recoveryIssue", JSON.stringify(result));
                setIssueLoaded('done');
            },
                (error) => {
                    console.log(error);
                });
        setIssueLoaded('done');
    }


    const getRecoveryResolution = () => {
        HttpService.post('/ServiceRecovery/GetRecoveryResolution', {
            data: null,
        })
            .then((result) => {
                console.log("GetRecoveryResolution : " + result)
                setRecoveryResolution(result);
                localStorage.setItem("recoveryResolution", JSON.stringify(result));
                setResolutionLoaded('done');
            },
                (error) => {
                    console.log(error);
                });
    }

    const contextValue = {
        recoveryIssue, issueLoaded, recoveryResolution, resolutionLoaded, getRecoveryIssue, getRecoveryResolution
    };
    return (
        <>
            <ServiceRecovery.Provider value={contextValue}>
                {props.children}
            </ServiceRecovery.Provider>
        </>
    );
}